<template>
  <div class="my-collection">
    <!-- 表格 -->
    <router-view :currentPage='currentPage' :pageTotal.sync='pageTotal' />

    <div class="page-num">
      <PageNum :pageSize='8' :pageTotal='pageTotal' :currentPage1.sync='currentPage' />
    </div>
  </div>
</template>

<script>
import utils from "@/util/index";
import PageNum from "@/components/common/PageNum";
export default {
  name: "MyCollection",
  components: {
    PageNum
  },

  data() {
    return {
      currentPage: 1,
      pageTotal: 0
    };
  }
};
</script>

<style lang='less' scoped>
.page-num {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  height: 40px;
}
</style> 